import React from 'react';
import { Heart, Eye, Handshake, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { useLanguage } from '../i18n';

const valueIcons = [Heart, Eye, Handshake];

const About = () => {
  const { t } = useLanguage();

  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-[#E9782A] font-semibold text-sm uppercase tracking-wider">
            {t.about.label}
          </span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            {t.about.titlePre}{' '}
            <span className="text-[#E9782A]">{t.about.titleHighlight}</span>
          </h2>
        </div>

        {/* Story + Mission */}
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-6" data-testid="about-story">
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.about.story1a}<strong className="text-gray-900">{t.about.story1b}</strong>{t.about.story1c}
              <strong className="text-[#E9782A]">{t.about.story1d}</strong>{t.about.story1e}
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              {t.about.story2}
            </p>
            <div className="bg-[#E9782A]/5 border-l-4 border-[#E9782A] rounded-r-xl p-6" data-testid="about-mission">
              <div className="flex items-center space-x-2 mb-2">
                <Sparkles className="text-[#E9782A]" size={20} />
                <h3 className="font-bold text-gray-900">{t.about.missionTitle}</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                {t.about.missionText}
              </p>
            </div>
          </div>

          {/* Values */}
          <div className="space-y-6">
            {t.about.values.map((value, index) => {
              const Icon = valueIcons[index];
              return (
                <Card key={value.title} className="border-2 border-gray-100 hover:border-[#E9782A]/20 transition-all duration-300 hover:shadow-lg">
                  <CardContent className="p-6">
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 rounded-xl bg-[#E9782A]/10 flex items-center justify-center flex-shrink-0">
                        <Icon className="text-[#E9782A]" size={24} />
                      </div>
                      <div>
                        <h3 className="font-bold text-gray-900 mb-1">{value.title}</h3>
                        <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
